<template>
  <div>
    <SearchPage
      v-if="node && node.title && searchSite"
      :title="node.title"
      :search-id="searchSite.id"
      :has-map="searchSite.hasMap"
      :has-location-filter="searchSite.hasLocationFilter"
      :has-currently-open-filter="searchSite.hasCurrentlyOpenFilter"
      :has-special-offers-filter="searchSite.hasSpecialOffersFilter"
    />
  </div>
</template>

<script lang="ts" setup>
import { SEARCH_SITES } from '../../settings'

definePageMeta({
  name: 'search-page',
})

const route = useRoute()

const searchSite = computed(() => {
  return SEARCH_SITES.find((v) => v.id === route.meta.searchSiteId)
})

if (!searchSite.value) {
  throw createError({
    statusCode: 404,
  })
}

const { entity: node, metatags } = await useDrupalRouteQuery(
  'singlePageApplication',
)

/* eslint-disable  @typescript-eslint/no-explicit-any */
useLogo().setLogoThemeFragment(node as any)
// The generic type V for the fragment can't be made compatible with these
// argument type, which is why we have to cast is as any here (which is fine).
/* eslint-disable  @typescript-eslint/no-explicit-any */
usePageTracking(node as any, metatags)
/* eslint-disable  @typescript-eslint/no-explicit-any */
setActiveChannel(node as any)

await renderPageDependencies()
</script>
